import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PersistConfig, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

type RealtorSearchState = {
  isProfit: boolean;
  searchVisible: boolean;
};

const initialState: RealtorSearchState = {
  isProfit: false,
  searchVisible: false
};

const realtorSearchSlice = createSlice({
  name: 'realtor-search-slice',
  initialState,
  reducers: {
    setRealtorSearchProfit: state => {
      state.isProfit = !state.isProfit;
    },
    setSearchVisible: (state, action: PayloadAction<boolean>) => {
      state.searchVisible = action.payload;
    }
  }
});

const config: PersistConfig<RealtorSearchState> = {
  storage,
  whitelist: ['isProfit'],
  key: 'realtor-view-profit'
};

export const realtorSearchReducer = persistReducer(config, realtorSearchSlice.reducer);
export const { setRealtorSearchProfit, setSearchVisible } = realtorSearchSlice.actions;
